import { Record } from 'immutable'

const ContactUserRecord = Record(
  {
    id: null,
    email: null,
    displayName: null,
    photoURL: null,
    username: '',
    organizationId: '',
  },
  'ContactUser'
)

export default ContactUserRecord
